import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { IFormConfig } from '../../../../types/form-builder';
import FormBuilder from '../../../common/form-builder/FormBuilder';

export default function NotesEditForm(props: {
  notesType: any;
  portNotesRef: any;
}) {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { notesType, portNotesRef } = props;

  const nameFormConfig: IFormConfig[] = [
    {
      class:
        'col-md-12 col-sm-12 col-lg-12 col-xs-12 col-xs-12 m-l-custom-sixteen-space-col',
      fieldWrapperClass: 'm-c-form-group mb-btm-space',
      name: 'noteType',
      label: 'Note Type',
      control: control,
      fieldType: 'select',
      dataSource: notesType,
      displayExpr: 'optionValueText',
      valueExpr: 'optionValueCode',
      ref: portNotesRef,
      isRequired: true,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-md-12 col-sm-12 col-lg-12 col-xs-12 col-xs-12 m-l-custom-sixteen-space-col',
      fieldWrapperClass: 'm-c-form-group mb-btm-space',
      name: 'notesDescription',
      label: 'Notes',
      control: control,
      fieldType: 'text',
      isRequired: true,
      ref: portNotesRef,
      maxLength: 100,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
  ];

  return (
    <div className="row m-l-custom-sixteen-space-row">
      <FormBuilder formConfig={nameFormConfig} />
    </div>
  );
}
